<template>
  <div class="modal fade confirm" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h3 v-if="refresh" class="modal-title">
            {{ titleName ? "備註_" : "編輯備註"
            }}<TruncateTool :content="titleName" :position="titleTipPosition" />
          </h3>
        </div>
        <div class="modal-body">
          <form>
            <div class="form-group">
              <textarea
                v-model="memoText"
                class="form-control modal-footer"
                rows="10"
                maxlength="400"
                @input="checkInputMemo"
                @blur="checkInputMemo"
              ></textarea>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <div class="text-right">
            <a @click="$emit('close')" class="btn btn-default"> 取消 </a>
            <a @click.stop.prevent="submit()" class="btn btn-primary"> 儲存 </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { insertMemo, modifyMemo } from "@/service";
import TruncateTool from "@/desktop/views/mv/PolicyInfo/components/TruncateTool.vue";

export default {
  name: "MemoModal",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    inputs: {
      type: Object,
      default: null,
    },
    titleName: {
      type: String,
      default: "",
    },
    titleTipPosition: {
      type: String,
      default: "top",
    },
  },
  watch: {
    open: "updateModal",
    titleName: {
      handler: function () {
        this.refresh = false;
        this.$nextTick(() => {
          this.refresh = true;
        });
      },
      deep: true,
    },
  },
  components: { TruncateTool },
  data() {
    return {
      memoText: "",
      refresh: true,
    };
  },
  methods: {
    //檢查備註
    checkInputMemo() {
      this.memoText = this.memoText.replace(/[{}[\]§|]/g, '');
      if (this.memoText && this.stringBytes(this.memoText, false, 400) > 400) {
        this.memoText = this.memoText.substring(
          0,
          this.stringBytes(this.memoText, true, 400)
        );
      }
    },
    stringBytes(c, isSub, size) {
      //計算字元長度 (字串, 是否檢查, 檢查的長度)
      var n = c.length,
        s;
      var len = 0;
      for (var i = 0; i < n; i++) {
        s = c.charCodeAt(i);
        while (s > 0) {
          len++;
          s = s >> 8;
          if (isSub && len > size) {
            return i;
          }
        }
      }
      return len;
    },
    checkWordLimit() {
      // 檢查欄位字數
      if (this.stringBytes(this.memoText, false, 400) > 400) {
        this.setToastMsg("內文不得超過200個中文字");
        return false;
      }

      return true;
    },
    submit() {
      if (this.checkWordLimit()) {
        // 檢查欄位字數
        let id = "";
        let custType = this.inputs.custType; //客戶類型
        if ("Y" === custType) {
          //有ID的客戶
          id = this.$store.state.custInfo.ID;
        } else {
          //無ID的客戶
          id = this.$store.state.custInfo.serNo;
        }
        if (this.inputs.isNew) {
          // 新增客戶備註
          insertMemo(
            this.$store.state.userInfo.id,
            id,
            this.memoText,
            custType
          ).then((result) => {
            if (result.header && result.header.status == "200") {
              this.setToastMsg(result.header.message);
              this.$emit("submit", this.memoText);
            } else {
              this.setToastMsg(result.header.message);
            }
          });
        } else {
          // 修改客戶備註
          modifyMemo(
            this.$store.state.userInfo.id,
            id,
            this.memoText,
            custType
          ).then((result) => {
            if (result.header && result.header.status == "200") {
              this.setToastMsg(result.header.message);
              this.$emit("submit", this.memoText);
            } else {
              this.setToastMsg(result.header.message);
            }
          });
        }
      }
    },
    updateModal() {
      this.memoText = this.inputs.memo;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
// .content-box {
//   border: rgb(206, 206, 206) solid 2px;
//   border-radius: 20px;
//   padding: 10px;
//   word-break: break-all;
// }
</style>